export default "__VITE_ASSET__B3gxada7__"